var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromoPickupIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 276,
    viewBox: "0 0 274 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_113_405",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 274,
    height: 276
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 276,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_113_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.027 88.9795L157.353 105.035L53.3818 74.7023L63.5904 39.7006L156.265 23.6446L260.236 53.9778L250.027 88.9795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.75 157.476L88.7613 194.734L44 281.566",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.269 217.022L112.101 229.487L85.4975 288.866",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.333 181.196L181.085 166.434",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.121 185.577L200.32 174.683",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.473 198.22L201.265 186.389",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.536 207.627L195.523 201.651",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5747 43.7724L167.812 70.1863L260.228 54.0557",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.838 70.1888L159.593 99.9805",
    stroke: "#696969",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoPickupIconMobile);
export default __webpack_public_path__ + "static/media/promo-pickup-icon-mobile.117d22b1604e40a49fba429e9058c5ee.svg";
export { ForwardRef as ReactComponent };